import queryString from 'query-string';
import _ from 'lodash';

const testKeys = ['test_lane', 'test_feature', 'test_feature_orbac', 'test_feature_finance', 'test_feature_cm'];
const testParams = testKeys.reduce((map, v) => {
  const value = queryString.parse(location.search)[v];
  return value ? { ...map, [v]: value } : map;
}, {});

// 当使用泳道访问时，自动拦截A标签和window.open方法，以添加泳道参数，对于location.href页面跳转无法自动拦截，需要业务层手动封装
function autoRun() {
  if (!_.isEmpty(testParams)) {
    interceptWindowOpen();
  }
}

// 拦截window.open方法
function interceptWindowOpen() {
  const oldFn = window.open;
  window.open = function (url, ...args) {
    oldFn(addTestLaneToUrl(url), ...args);
  };
}

// url中添加泳道信息
export function addTestLaneToUrl(url) {
  if (_.isEmpty(testParams)) {
    return url;
  }

  if (url) {
    const includeTestParams = Object.keys(testParams).every((v) => url.includes(v));
    if (includeTestParams) {
      return url;
    }
  }
  // hash处理
  const hashIndex = url ? url.indexOf('#') : -1;
  let hashStr = '';
  if (hashIndex >= 0) {
    hashStr = url.substring(hashIndex);
    url = url.substring(0, hashIndex);
  }
  // search处理
  const searchIndex = url ? url.indexOf('?') : -1;
  if (searchIndex < 0) {
    return `${url || ''}?${queryString.stringify(testParams)}${hashStr}`;
  }
  let query = queryString.parse(url.substring(searchIndex));
  query = Object.keys(testParams).reduce((map, v) => {
    return { ...map, [v]: testParams[v] };
  }, query);
  return `${url.substring(0, searchIndex)}?${queryString.stringify(query)}${hashStr}`;
}

autoRun();
